export const ANNUAL_RATE = 0.299;

export const FINANCING_TERMS = [12, 24, 36, 48, 60];

// Plazo usado para calcular las cuotas aproximadas cuando la planilla no trae la columna CUOTA.
export const DEFAULT_INSTALLMENTS = 48;

export function calcInstallment(principal: number, months: number, annualRate: number = ANNUAL_RATE): number {
  const r = annualRate / 12;
  if (r === 0) return Math.round(principal / months);
  return Math.round((principal * r) / (1 - Math.pow(1 + r, -months)));
}
